import isEmail from 'validator/lib/isEmail'

export const required = async (v: string) => {
  return !!v || 'This field is required'
}

export const requiredArray = async (v: unknown[]) => {
  return (Array.isArray(v) && v.length > 0) || 'This field is required'
}

export const requiredTerms = async (v: string) => {
  return !!v || 'You must agree to the terms.'
}

export const requiredNumeric = async (v: number | string) => {
  return (
    (v !== '' && v !== null && v !== undefined && !isNaN(Number(v))) || 'This field is required'
  )
}

export const validEmail = async (v: string) => {
  return isEmail(v) || 'Invalid email address'
}

export const postalCodeRule = async (v: string) => {
  const regex = /^(?:[A-Z]\d[A-Z]\s?\d[A-Z]\d|\d{5}(?:[-\s]\d{4})?)$/i
  return regex.test(v) || 'Invalid Postal Code'
}
